import { IPersonMaidenItem } from "../interfaces";

const DEF_TIME = "12:00:00";

export const MAIDEN_ITEMS: {[key: string]: Array<IPersonMaidenItem>;} = {
	LEN_MAK: [
		{ fromDate: `2022-05-28 13:00:00`, toDate: ``, surname: "Makuderová" },
		{ fromDate: ``, toDate: `2022-05-27`, surname: "Sumbalová" },
	],
	TAM_SUM: [
		{ fromDate: `2019-09-21 ${DEF_TIME}`, toDate: ``, surname: "Sumbalová" },
		{ fromDate: ``, toDate: `2019-09-09`, surname: "Kyprová" },
	],
	IVE_BAZ: [
		{ fromDate: `2024-07-01 ${DEF_TIME}`, toDate: ``, surname: "Flajsarová" },
		{ fromDate: `2009-08-07 ${DEF_TIME}`, toDate: `2024-06-31 ${DEF_TIME}`, surname: "Bažantová" },
		{ fromDate: `1987-02-14 ${DEF_TIME}`, toDate: `2009-08-06`, surname: "Makuderová" },
		{ fromDate: ``, toDate: `1987-02-13`, surname: "Flajsarová" },
	],
	ZUZ_SUM: [
		{ fromDate: `2022-04-02 ${DEF_TIME}`, toDate: ``, surname: "Sumbalová" },
		{ fromDate: ``, toDate: `2022-04-01`, surname: "Koledová" },
	],
	LEO_MAK: [
		// odhad
		{ fromDate: `2022-06-01 ${DEF_TIME}`, toDate: ``, surname: "Makudera" },
		{ fromDate: `2014-06-21 ${DEF_TIME}`, toDate: `2022-05-31`, surname: "Ožvoldová" },
		{ fromDate: ``, toDate: `2014-06-20`, surname: "Makuderová" },
	],
	JAN_SIM: [
		{ fromDate: `2015-07-25 ${DEF_TIME}`, toDate: ``, surname: "Šimečková" },
		// odhad
		{ fromDate: `1994-06-01 ${DEF_TIME}`, toDate: `2015-07-24`, surname: "Rábová" },
		{ fromDate: ``, toDate: `1994-05-31`, surname: "Flajsarová" },
	],
	PET_PRI: [
		{ fromDate: `2017-06-24 ${DEF_TIME}`, toDate: ``, surname: "Příkazská" },
		{ fromDate: ``, toDate: `2017-06-23`, surname: "Vymyslická" },
	],
	EVA_CER: [
		{ fromDate: `2019-08-17 ${DEF_TIME}`, toDate: ``, surname: "Červenková" },
		{ fromDate: ``, toDate: `2019-08-16`, surname: "Fillová" },
	],
	LEN_VOJ: [
		{ fromDate: `2020-07-25 ${DEF_TIME}`, toDate: ``, surname: "Vojtíšková" },
		{ fromDate: ``, toDate: `2020-07-24`, surname: "Blahová" },
	],
	VER_LAN: [
		{ fromDate: `2016-07-16 ${DEF_TIME}`, toDate: ``, surname: "Láníčková" },
		{ fromDate: ``, toDate: `2016-07-15`, surname: "Benešovská" },
	],
	ERI_VEV: [
		{ fromDate: `2023-11-20 ${DEF_TIME}`, toDate: ``, surname: "Jirkuv" },
		{ fromDate: ``, toDate: `2023-11-19`, surname: "Veverková" },
	],
	VER_PUL: [
		{ fromDate: `2016-07-11 ${DEF_TIME}`, toDate: ``, surname: "Půlkrábková" },
		{ fromDate: ``, toDate: `2016-07-10`, surname: "Zhřívalová" },
	],
	HAN_DLA: [
		{ fromDate: `2015-05-02 ${DEF_TIME}`, toDate: ``, surname: "Dlabajová" },
		{ fromDate: ``, toDate: `2015-05-01`, surname: "Viktorínová" },
	],
	SIM_BAK: [
		{ fromDate: `2019-06-29 ${DEF_TIME}`, toDate: ``, surname: "Bakalová" },
		{ fromDate: ``, toDate: `2019-06-28`, surname: "Mazalová" },
	],
	LUC_ROB: [
		{ fromDate: `2010-08-14 ${DEF_TIME}`, toDate: ``, surname: "Robková" },
		{ fromDate: ``, toDate: `2010-08-13`, surname: "Cvanová" },
	],
	ZUZ_KRA: [
		{ fromDate: `2012-05-12 ${DEF_TIME}`, toDate: ``, surname: "Krátká" },
		{ fromDate: ``, toDate: `2012-05-11`, surname: "Esterková" },
	],
	JAR_SAL: [
		{ fromDate: `2013-09-22 ${DEF_TIME}`, toDate: ``, surname: "Salajková" },
		{ fromDate: ``, toDate: `2013-09-21`, surname: "Sládková" },
	],
	JAN_HAN: [
		{ fromDate: `2016-10-15 ${DEF_TIME}`, toDate: ``, surname: "Hanáková" },
		{ fromDate: ``, toDate: `2016-10-14`, surname: "Komosná" },
	],
	TER_ZDY: [
		{ fromDate: `2016-10-08 ${DEF_TIME}`, toDate: ``, surname: "Ždychová" },
		{ fromDate: ``, toDate: `2016-10-07`, surname: "Přikrylová" },
	],
	VER_MAK: [
		{ fromDate: `2019-06-22 ${DEF_TIME}`, toDate: ``, surname: "Makuderová" },
		{ fromDate: ``, toDate: `2019-06-21`, surname: "Šindarová" },
	],
	MIC_SIN: [
		{ fromDate: `2016-08-13 ${DEF_TIME}`, toDate: ``, surname: "Šindarová" },
		{ fromDate: ``, toDate: `2016-08-12`, surname: "Mrkvová" },
	],
	JAR_STE: [
		{ fromDate: `2013-07-27 ${DEF_TIME}`, toDate: ``, surname: "Štěpánková" },
		{ fromDate: ``, toDate: `2013-07-26`, surname: "Nováková" },
	],
	SVA_SUM: [
		{ fromDate: `1989-11-11 ${DEF_TIME}`, toDate: ``, surname: "Sumbalová" },
		{ fromDate: ``, toDate: `1989-11-10`, surname: "Tichavská" },
	],
	JAR_MAK: [
		{ fromDate: `2007-06-09 ${DEF_TIME}`, toDate: ``, surname: "Makuderová" },
		{ fromDate: ``, toDate: `2007-06-08`, surname: "Holešinská" },
	],
	IVC_PIV: [
		{ fromDate: `2019-01-01 ${DEF_TIME}`, toDate: ``, surname: "Doležal" },
		{ fromDate: ``, toDate: `2019-01-01 11:59:59`, surname: "Pivčica" },
	],
	MAR_PAS: [
		{ fromDate: `2026-06-06 12:00:00`, toDate: ``, surname: "Pašová" },
		{ fromDate: ``, toDate: `1997-04-03`, surname: "Naušová" },
	],
};
